import httpClient from '@/apis/base/httpclient';
import BaseAPI from '../base/baseApi';

class taskManagementApi extends BaseAPI {
  apiName = 'Business';
  controllerName = 'TaskManagement';

  /**
   * lấy dữ liệu task để kiểm tra trạng thái
   * ntduong2 13.11.2024
   */
  getTaskManagement(task_id) {
    const request = {
      url: [this.getAPIUrl(), '/getTaskManagement'].join(''),
      data: {task_id},
    };

    return this.getAsync(request);
  }
}

export default new taskManagementApi();
